import { render, staticRenderFns } from "./PreferencesPayments.vue?vue&type=template&id=4d80ea96"
import script from "./PreferencesPayments.vue?vue&type=script&lang=js"
export * from "./PreferencesPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports